import { render, staticRenderFns } from "./IndicationResultPrintTemplate.vue?vue&type=template&id=897a9dc6&scoped=true"
import script from "./IndicationResultPrintTemplate.vue?vue&type=script&lang=js"
export * from "./IndicationResultPrintTemplate.vue?vue&type=script&lang=js"
import style0 from "./IndicationResultPrintTemplate.vue?vue&type=style&index=0&id=897a9dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897a9dc6",
  null
  
)

export default component.exports